import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';

const LandNumberInput = forwardRef(({ onChange, value, ...restProps }, ref) => (
  <IMaskInput
    mask="0000000000:00:000:0000"
    inputRef={ref}
    onAccept={(v, input, e) => onChange(e, v)}
    overwrite
    value={value}
    {...restProps}
  />
));

LandNumberInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

LandNumberInput.defaultProps = {
  value: '',
};

export default LandNumberInput;
